import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6031781e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "item"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "产品信息", -1))
const _hoisted_5 = { class: "value" }
const _hoisted_6 = {
  key: 0,
  style: {"display":"flex","justify-content":"space-between","align-items":"center"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "【是否处方药】", -1))
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "招商要求", -1))
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "value" }

import { computed } from 'vue';
import { Zs } from '../../data-source/types';
import { BaseSelect } from 'xrk-components';
import { PRESCRIPTION_TYPE, PRODUCT_DEVICE, PRODUCT_DRUG } from '../../config';

export default /*#__PURE__*/_defineComponent({
  __name: 'config-detail',
  props: {
    perviewRole: {},
    content: {},
    productData: {},
    tags: {},
    tagValues: {}
  },
  setup(__props: any) {

const props = __props;

const showOtcContent = props.perviewRole === 'oss';

const tagsMap = computed(() => {
  return props.tags?.reduce((pre, cur) => {
    cur.childList?.forEach(i => {
      pre[`${cur.id}_${i.id}`] = i;
    });
    return pre;
  }, {} as Record<string, Zs['row']['tags'][number]>);
});

const getTagLabel = (tag: Zs['row']['tags'][number]) => {
  if (tag.isLocation) {
    return (tag.chooseTagValuesStr?.map(i => i.value) || []).join('、');
  }
  return tag.chooseTagValues
    ?.map(i => tagsMap.value?.[`${tag.id}_${i}`]?.name)
    .filter(Boolean)
    .join('、');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.content)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "value",
            innerHTML: _ctx.content
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productData, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "value-item",
          key: item.id
        }, [
          _createElementVNode("div", _hoisted_5, [
            (item.type === _unref(PRODUCT_DRUG))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  showOtcContent
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode(_unref(BaseSelect), {
                          disabled: item.isOtcFixed == 1,
                          style: {"width":"100px"},
                          options: _unref(PRESCRIPTION_TYPE),
                          modelValue: item.isOtc,
                          "onUpdate:modelValue": ($event: any) => ((item.isOtc) = $event)
                        }, null, 8, ["disabled", "options", "modelValue", "onUpdate:modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
              { label: '批准文号', value: item.approvalNumber, show: true },
              { label: '药品名称', value: item.name, show: true },
              { label: '商品名称', value: item.productName, show: true },
              { label: '药品类型', value: item.medicineType, show: true },
              { label: '剂型', value: item.jixing, show: true }
            ].filter(i => i.show), ({ label, value }, index) => {
                    return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(`【${label}】：${value || '-'}`), 1))
                  }), 128))
                ], 64))
              : _createCommentVNode("", true),
            (item.type === _unref(PRODUCT_DEVICE))
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList([
              { label: '批准文号', value: item.approvalNumber },
              { label: '器械名称', value: item.name },
              { label: '型号规格', value: item.guige }
            ], ({ label, value }, index) => {
                  return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(`【${label}】：${value || '-'}`), 1))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      (_ctx.tags)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.tags, (tag) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tag.id
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", null, _toDisplayString(tag.name) + "：" + _toDisplayString(getTagLabel(tag)), 1)
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.tagValues)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.tagValues, (tag) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tag.label
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", null, _toDisplayString(tag.label) + "：" + _toDisplayString(tag.options), 1)
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})